import { IoSearchSharp } from 'react-icons/io5'
import { usePairSelect } from './core'
import { Text, useMainContext } from '../../../../modules/Dashboard'
import PairImg from '../../components/PairImg'
import { ReactComponent as PairVector } from '../../assets/icons/choose-pair-vector.svg';
import MobileModal from '../../../../components/layouts/MobileModal';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';

const RPairSelect = ({ className = '', dropdownClass = '' }) => {
    const {
        ticker,
        search,
        setSearch,
        open,
        setOpen,
        tickers,
        isFetching,
        isError,
        refetch,
        handleSelect,
    } = usePairSelect()

    const {
        main: { lang },
    } = useMainContext()

    const handlePairSelect = (selectedTicker) => {
        handleSelect(selectedTicker);
        setOpen(false); // Close modal after selection
    }

    return (
        <>
            <div className='flex items-center gap-2 mb-2'>
                <PairVector width={35} height={35} />
                <Text tid="choose-pair" className='text-xl' />
            </div>

            {/* Toggler Button */}
            <button
                onClick={() => setOpen(true)}
                className={`relative w-full flex items-center gap-2 px-4 py-3 rounded-xl border border-[#364153] transition-colors mt-5 ${className}`}
            >
                <Text tid={"ticker"} className='absolute -top-8 ltr:left-0 rtl:right-0 text-sm text-[#C27AFF]' />
                <span className="font-medium text-[#6A7282] text-sm">
                    {ticker ? ticker : (lang === 'fa' ? 'انتخاب ارز...' : 'Choose a pair to analyze')}
                </span>
                {open ? (
                    <BiChevronUp color="#6A7282" className="absolute ltr:right-3 rtl:left-3 top-1/2 -translate-y-1/2" size={20} />
                ) : (
                    <BiChevronDown color="#6A7282" className="absolute ltr:right-3 rtl:left-3 top-1/2 -translate-y-1/2" size={20} />
                )}
            </button>

            {/* Mobile Modal */}
            <MobileModal
                isOpen={open}
                onClose={() => setOpen(false)}
                noBg
                noPadding
            >
                <div className='bg-gradient-to-br from-[#101828] via-[#3C0366] to-[#101828] rounded-t-xl p-4'>
                    {/* TITLE */}
                    <div className='text-center w-full'>
                        <Text tid={"choose-pair"} className='text-xl' />
                    </div>

                    {/* Search Input */}
                    <div className="px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                        <div className="relative">
                            <IoSearchSharp
                                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                                size={20}
                            />
                            <input
                                type="text"
                                placeholder={lang === 'fa' ? 'جستجوی ارز...' : 'Search pairs...'}
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                className="w-full pl-10 pr-4 py-3 bg-gray-100 dark:bg-gray-800 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                    </div>

                    {/* Content */}
                    <div className="flex-1 overflow-y-auto">
                        {isFetching ? (
                            <div className="flex justify-center items-center py-8">
                                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                            </div>
                        ) : isError ? (
                            <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
                                <Text
                                    tid={lang === 'fa' ? 'خطای ناشناخته' : 'Unknown error'}
                                    className="text-red-500 mb-4"
                                />
                                <button
                                    onClick={refetch}
                                    className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                                >
                                    {lang === 'fa' ? 'تلاش مجدد' : 'Retry'}
                                </button>
                            </div>
                        ) : (
                            <div className="py-2">
                                {tickers.length === 0 ? (
                                    <div className="text-center py-8 text-gray-500 dark:text-gray-400">
                                        {lang === 'fa' ? 'موردی یافت نشد' : 'No results found'}
                                    </div>
                                ) : (
                                    tickers.map((item) => (
                                        <button
                                            key={item.ticker}
                                            onClick={() => handlePairSelect(item.ticker)}
                                            className="w-full px-4 py-3 flex items-center gap-3 transition-colors  odd:bg-[#300258] even:bg-[#2B034E] rounded-lg "
                                        >
                                            <PairImg ticker={item.ticker} size={32} />
                                            <span className="font-medium text-sm">{item.ticker}</span>
                                        </button>
                                    ))
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </MobileModal>
        </>
    )
}

export default RPairSelect